module.exports = __webpack_public_path__ + "img/zhst1.b7b68090.png";